'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var Panel = require('@narvar/nth-block-panel');
var useOrderTracking = require('@narvar/nth-hook-order-tracking');
var Status = require('./components/Status.js');
var Stepper = require('./components/Stepper.js');
var DeliveryHistory = require('./components/DeliveryHistory.js');
var utils = require('./utils.js');
var Icons = require('./components/Icons.js');
var TrackingNumber = require('./components/TrackingNumber.js');
var PrefetchData = require('./PrefetchData.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Panel__default = /*#__PURE__*/_interopDefaultLegacy(Panel);
var useOrderTracking__default = /*#__PURE__*/_interopDefaultLegacy(useOrderTracking);

const DeliveryStatus = ({
  featureName,
  fixedPanelHeight
}) => {
  const {
    panelcontainerNoneNone: containerStyle,
    panelbodyNoneNone: panelBodyStyle,
    iconsPrimaryNone
  } = nthHookTheme.useTheme();
  const {
    getCurrentShipment
  } = useOrderTracking__default["default"]();
  const currentShipment = getCurrentShipment();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    if (!currentShipment) return;
    logEvent({
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DELIVERY_STATUS,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DELIVERY_STATUS,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BLOCK_DELIVERY_STATUS
    });
  }, [currentShipment, logEvent, featureName]);
  if (!currentShipment) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  const {
    carrier,
    carrierLogoUrl,
    displayDate,
    displayDateRange,
    status,
    statusCode,
    history
  } = currentShipment;
  if (typeof statusCode !== 'string' || typeof status !== 'string') {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  }
  const LastMileIcons = {
    activeIcons: [/*#__PURE__*/React__default["default"].createElement(Icons.CarActive, {
      key: "mapview_car_active",
      style: iconsPrimaryNone
    }), /*#__PURE__*/React__default["default"].createElement(Icons.HouseActive, {
      key: "mapview_house_active",
      style: iconsPrimaryNone
    })],
    inactiveIcons: [/*#__PURE__*/React__default["default"].createElement(Icons.Car, {
      key: "mapview_car_inactive",
      style: iconsPrimaryNone
    }), /*#__PURE__*/React__default["default"].createElement(Icons.House, {
      key: "mapview_house_inactive",
      style: iconsPrimaryNone
    })],
    error: [/*#__PURE__*/React__default["default"].createElement(Icons.Error, {
      key: "mapview_error",
      style: iconsPrimaryNone
    }), /*#__PURE__*/React__default["default"].createElement(Icons.House, {
      key: "mapview_house error",
      style: iconsPrimaryNone
    })]
  };
  const LDIcons = {
    activeIcons: [
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.OrderActive, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.StoreActive, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.CarActive, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.HouseActive, {
      style: iconsPrimaryNone
    })],
    inactiveIcons: [
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Order, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Store, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Car, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.House, {
      style: iconsPrimaryNone
    })],
    error: [
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Order, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Error, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.House, {
      style: iconsPrimaryNone
    })]
  };
  const HPUIcons = {
    activeIcons: [
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Scheduled, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.CarActive, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.CheckMarkActive, {
      style: iconsPrimaryNone
    })],
    inactiveIcons: [
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Scheduled, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Car, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.CheckMark, {
      style: iconsPrimaryNone
    })],
    error: [
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Order, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.Error, {
      style: iconsPrimaryNone
    }),
    /*#__PURE__*/
    // TODO: refactor this instead of disabling
    // eslint-disable-next-line react/jsx-key
    React__default["default"].createElement(Icons.House, {
      style: iconsPrimaryNone
    })]
  };
  const deliveryIcons = () => {
    switch (status) {
      case 'HPUSCHEDULED':
      case 'HPUEXCEPTION':
      case 'HPUPICKUPINPROGRESS':
      case 'HPUPICKEDUP':
        return HPUIcons;
      case 'MVINTRANSIT':
      case 'MVDELIVERED':
      case 'MVEXCEPTION':
        return LastMileIcons;
      default:
        return LDIcons;
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(Panel__default["default"], {
    header: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null),
    sOuter: {
      boxSizing: 'border-box',
      ...containerStyle,
      height: fixedPanelHeight || containerStyle && containerStyle.height || '100%',
      overflowX: 'hidden' // Needed for the <Row /> to have negative margins without scrollbar
    },
    sInner: {
      margin: '0rem auto',
      ...panelBodyStyle,
      height: fixedPanelHeight ? 'auto' : '100%',
      maxHeight: fixedPanelHeight ? '100%' : 'auto',
      overflowX: 'hidden' // Needed for the <Row /> to have negative margins without scrollbar
    }
  }, typeof displayDate === 'string' && /*#__PURE__*/React__default["default"].createElement(Status["default"], {
    featureName: featureName,
    displayDate: displayDate,
    displayDateRange: displayDateRange,
    translations: {
      status,
      category: statusCode
    }
  }), /*#__PURE__*/React__default["default"].createElement(Stepper["default"], _extends__default["default"]({
    icons: deliveryIcons(),
    stepperColor: iconsPrimaryNone?.color
  }, utils.getStepperInfo(status, statusCode))), history?.length > 0 && /*#__PURE__*/React__default["default"].createElement(DeliveryHistory["default"], {
    featureName: featureName,
    history: history
  }), /*#__PURE__*/React__default["default"].createElement(TrackingNumber["default"], {
    featureName: featureName
    // `carrier` and `carrierLogoUrl` are nullable on the orderTracking query because of
    // scenarios like preship and bopis. However, it will be populated with
    // at least the generic carrier and logo url in every other case.
    ,
    carrier: carrier || '',
    carrierLogoUrl: carrierLogoUrl || ''
  }));
};
const DeliveryStatusWithData = nthHookTheme.withThemeProvider(DeliveryStatus, {
  themeTokens: ['spinnerPrimaryNone', 'panelcontainerNoneNone', 'panelbodyNoneNone', 'iconsPrimaryNone']
});
const DeliveryStatusWithPrefetchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(DeliveryStatusWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports["default"] = DeliveryStatusWithPrefetchedData;
